var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "doc_sb_edit p-3" }, [
    _c(
      "div",
      { staticClass: "template p-3" },
      [
        _c("organization_select", {
          attrs: { active_id: parseInt(_vm.cur_tov_id) },
          on: { on_organization_set: _vm.set_org_id },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "template p-3" }, [
      _c("div", { staticClass: "form-group" }, [
        _c(
          "label",
          { staticClass: "form-label", attrs: { for: "payment_online" } },
          [
            _vm._v(
              "\n                Виберiть з випадаючого списку стан*\n            "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("b-form-radio-group", {
              attrs: {
                id: "btn-radios-1",
                "button-variant": "outline-primary",
                options: _vm.rating_variants,
                name: "radios-btn-default",
                buttons: "",
              },
              model: {
                value: _vm.doc_rating,
                callback: function ($$v) {
                  _vm.doc_rating = $$v
                },
                expression: "doc_rating",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "template p-3" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "payment_online" } },
        [_vm._v("\n            Введiть коментар\n        ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "select_step" },
        [
          _c("b-textarea", {
            attrs: { rows: 10 },
            model: {
              value: _vm.doc_comment,
              callback: function ($$v) {
                _vm.doc_comment = $$v
              },
              expression: "doc_comment",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }